import {
	FETCH_INVENTORY_ITEMS,
	DELETE_INVENTORY,
	FETCH_BUCKET_LIST,
	CLONE_BUCKET,
	UPDATE_BUCKET_PRICE,
	UPDATE_BUCKET,
	UPDATE_STATUS,
	UPDATE_BUCKET_ORDER,
	DELETE_BUCKET,
	SET_UPLOAD_INVENTORY_FILE_ACTION,
	SET_UPLOAD_INVENTORY_FILE_BATCH,
	SET_CATEGORY_OPTIONS,
	SET_SUBCATEGORY_OPTIONS,
	SET_SUBSUBCATEGORY_OPTIONS,
	SET_MAPPED_SUPPLIER_OPTIONS,
	SET_MAPPED_DSO_OPTIONS,
	SET_PACKAGING_OPTIONS,
	SET_MANUFACTURER_OPTIONS,
	SET_PROCEDURES,
	UPDATE_BUCKETS,
	SET_PROCEDURE_ENUMS,
	SET_DENTIRA_PRODUCT_NAME_TO_ID_MAP,
} from './types';
import { getDentalCorpBackend } from '../commons/backend/dentalCorpBackendProxy';
import { SPJ_ACTIONS, SPJ_STATUS, BULK_FILE_UPLOAD_STAGES } from '../commons/utils';

const dentalCorpBackend = getDentalCorpBackend();

export const fetchInventoryItems = (body) => {
	return async (dispatch, getState) => {
		let { response } = (await dentalCorpBackend.fetchInventoryItems(getState(), body, dispatch)) || {};
		if (response !== null && response !== undefined) {
			dispatch({ type: FETCH_INVENTORY_ITEMS, payload: response });
		}
		return response;
	};
};

export const updateBucketPrice = (supplier_product_id, source, price) => {
	return async (dispatch, getState) => {
		let body = {
			supplier_product_id,
			price,
		};
		let response = await dentalCorpBackend.updateBucketPrice(getState(), source, body, dispatch);
		if (response !== null && response !== undefined) {
			dispatch({ type: UPDATE_BUCKET_PRICE, payload: response.response });
		}
	};
};

export const fetchBucketList = () => {
	return async (dispatch, getState) => {
		let response = await dentalCorpBackend.fetchBucketList(getState(), dispatch);
		if (response !== null && response !== undefined) {
			dispatch({ type: FETCH_BUCKET_LIST, payload: response.response });
		}
	};
};

export const createBucket = (supplier, alias) => {
	return async (dispatch, getState) => {
		let body = {
			alias,
		};
		let response = await dentalCorpBackend.createBucket(getState(), supplier, body, dispatch);
		if (response !== null && response !== undefined) {
			// dispatch({ type: CREATE_BUCKET, payload: response.response });
		}
	};
};

export const cloneBucket = (bucketDetails) => {
	let body = bucketDetails;
	return async (dispatch, getState) => {
		let response = await dentalCorpBackend.cloneBucket(getState(), body, dispatch);
		if (response !== null && response !== undefined) {
			dispatch({ type: CLONE_BUCKET, payload: response.response });
		}
	};
};

export const updateBucket = (alias, source) => {
	return async (dispatch, getState) => {
		let body = {
			alias,
			source,
		};
		let response = await dentalCorpBackend.updateBucket(getState(), body, dispatch);
		if (response !== null && response !== undefined) {
			dispatch({ type: UPDATE_BUCKET, payload: response.response });
		}
	};
};

export const updateStatus = (supplier_product_id, availability_status) => {
	return async (dispatch, getState) => {
		let body = {
			supplier_product_id,
			availability_status,
		};
		let response = await dentalCorpBackend.updateStatus(getState(), body, dispatch);
		if (response !== null && response !== undefined) {
			dispatch({ type: UPDATE_STATUS, payload: response.response });
		}
	};
};

export const updateBucketOrder = (order) => {
	return async (dispatch, getState) => {
		dispatch({ type: UPDATE_BUCKET_ORDER, payload: order });
	};
};

export const deleteBucket = (source) => {
	const body = {
		source: source,
	};
	return async (dispatch, getState) => {
		let response = await dentalCorpBackend.deleteBucket(getState(), body, dispatch);
		if (response !== null && response !== undefined) {
			dispatch({ type: DELETE_BUCKET, payload: response.response });
		}
	};
};

export const fetchFileUploadURL = (extension) => {
	const app = 'sellerportal';
	const folder = 'products';
	return async (dispatch, getState) => {
		let response = await dentalCorpBackend.fetchFileUploadURL(getState(), app, extension, folder, dispatch);
		if (response !== null && response !== undefined) {
			return response.response;
		}
	};
};

export const uploadFile = (url, blob, type) => {
	return async (dispatch, getState) => {
		let response = await dentalCorpBackend.uploadFile(getState(), url, blob, type, dispatch);
		if (response !== null && response !== undefined) {
			return response.response;
		}
	};
};

export const fetchAutocompleteManufacturer = (search = '', size = 0) => {
	return async (dispatch, getState) => {
		let body = {};
		let response = await dentalCorpBackend.fetchAutocompleteManufacturer(getState(), body, search, size, dispatch);
		if (response !== null && response !== undefined) {
			let manufacturerOptions = response.response || [];
			manufacturerOptions = [...new Set(manufacturerOptions || [])];
			manufacturerOptions = manufacturerOptions
				.filter((option) => option)
				.map((option) => ({
					name: option,
					value: option,
					disabled: false,
				}));
			manufacturerOptions = manufacturerOptions.sort((item1, item2) => (item1.name > item2.name ? 1 : item2.name > item1.name ? -1 : 0));
			dispatch({ type: SET_MANUFACTURER_OPTIONS, payload: manufacturerOptions });
		}
	};
};

export const fetchAutocompleteMappedSupplier = (search = '', size = 0) => {
	return async (dispatch, getState) => {
		let body = {};
		let response = await dentalCorpBackend.fetchAutocompleteMappedSupplier(getState(), body, search, size, dispatch);
		if (response !== null && response !== undefined) {
			let supplierMap = getState().supplier.suppliers_map || {};
			let mappedSupplierOptions = response.response || [];
			mappedSupplierOptions = [...new Set(mappedSupplierOptions || [])];
			mappedSupplierOptions = mappedSupplierOptions
				.filter((option) => option)
				.map((option) => ({
					name: (supplierMap[option] ? supplierMap[option].name : option).toUpperCase(),
					value: option.value,
					disabled: false,
				}));
			mappedSupplierOptions = mappedSupplierOptions.sort((item1, item2) => (item1.name > item2.name ? 1 : item2.name > item1.name ? -1 : 0));
			dispatch({ type: SET_MAPPED_SUPPLIER_OPTIONS, payload: mappedSupplierOptions });
		}
	};
};

export const fetchAutocompletePackaging = (search = '', size = 0) => {
	return async (dispatch, getState) => {
		let body = {};
		let response = await dentalCorpBackend.fetchAutocompletePackaging(getState(), body, search, size, dispatch);
		if (response !== null && response !== undefined) {
			let packagingOptions = response.response || [];
			packagingOptions = packagingOptions.map((option) => ({
				name: `${option.name.toUpperCase()}`,
				value: option.value,
				disabled: false,
			}));
			packagingOptions = packagingOptions.sort((item1, item2) => (item1.name > item2.name ? 1 : item2.name > item1.name ? -1 : 0));
			dispatch({ type: SET_PACKAGING_OPTIONS, payload: packagingOptions });
		}
	};
};

export const fetchAutocompleteMappedDSO = (search = '', size = 0) => {
	return async (dispatch, getState) => {
		let body = {};
		let response = await dentalCorpBackend.fetchAutocompleteMappedDSO(getState(), body, search, size, dispatch);
		if (response !== null && response !== undefined) {
			let mappedDSOOptions = response.response || [];
			mappedDSOOptions = mappedDSOOptions.map((option) => ({
				name: option.name.toUpperCase(),
				value: option.value,
				disabled: false,
			}));
			mappedDSOOptions = mappedDSOOptions.sort((item1, item2) => (item1.name > item2.name ? 1 : item2.name > item1.name ? -1 : 0));
			dispatch({ type: SET_MAPPED_DSO_OPTIONS, payload: mappedDSOOptions });
		}
	};
};

export const fetchAutocompleteCategory = (search = '', size = 0) => {
	return async (dispatch, getState) => {
		let body = {};
		let response = await dentalCorpBackend.fetchAutocompleteCategory(getState(), body, search, size, dispatch);
		if (response !== null && response !== undefined) {
			let categoryOptions = response.response || [];
			categoryOptions = categoryOptions.map((option) => ({
				name: option.name.toUpperCase(),
				value: option.value,
				disabled: false,
			}));
			categoryOptions = categoryOptions.sort((item1, item2) => (item1.name > item2.name ? 1 : item2.name > item1.name ? -1 : 0));
			dispatch({ type: SET_CATEGORY_OPTIONS, payload: categoryOptions });
		}
	};
};

export const fetchAutocompleteSubCategory = (category = '', search = '', size = 0) => {
	return async (dispatch, getState) => {
		let body = {
			category: category,
		};
		let response = await dentalCorpBackend.fetchAutocompleteSubCategory(getState(), body, search, size, dispatch);
		if (response !== null && response !== undefined) {
			let subCategoryOptions = response.response || [];
			subCategoryOptions = subCategoryOptions.map((option) => ({
				name: option.name.toUpperCase(),
				value: option.value,
				disabled: false,
			}));
			subCategoryOptions = subCategoryOptions.sort((item1, item2) => (item1.name > item2.name ? 1 : item2.name > item1.name ? -1 : 0));
			dispatch({ type: SET_SUBCATEGORY_OPTIONS, payload: subCategoryOptions });
		}
	};
};

export const fetchAutocompleteSubSubCategory = (category = '', subcategory = '', search = '', size = 0) => {
	return async (dispatch, getState) => {
		let body = {
			category: category,
			subcategory: subcategory,
		};
		let response = await dentalCorpBackend.fetchAutocompleteSubSubCategory(getState(), body, search, size, dispatch);
		if (response !== null && response !== undefined) {
			let subSubCategoryOptions = response.response || [];
			subSubCategoryOptions = subSubCategoryOptions.map((option) => ({
				name: option.name.toUpperCase(),
				value: option.value,
				disabled: false,
			}));
			subSubCategoryOptions = subSubCategoryOptions.sort((item1, item2) => (item1.name > item2.name ? 1 : item2.name > item1.name ? -1 : 0));
			dispatch({ type: SET_SUBSUBCATEGORY_OPTIONS, payload: subSubCategoryOptions });
		}
	};
};

export const createInventory = (requestObj) => {
	return async (dispatch, getState) => {
		let response = await dentalCorpBackend.createInventory(getState(), requestObj, dispatch);
		if (response !== null && response !== undefined) {
			return response.response;
		}
	};
};

export const fetchInventory = (supplier_product_id) => {
	return async (dispatch, getState) => {
		let body = {
			supplier_product_id,
		};
		let response = await dentalCorpBackend.fetchInventory(getState(), body, dispatch);
		if (response !== null && response !== undefined) {
			return response.response;
		}
	};
};

export const updateInventory = (supplier_product_id, requestObj) => {
	return async (dispatch, getState) => {
		let body = {
			supplier_product_id,
			...requestObj,
		};
		let response = await dentalCorpBackend.updateInventory(getState(), body, dispatch);
		if (response !== null && response !== undefined) {
			return response.response;
		}
	};
};

export const deleteInventory = (supplier_product_id) => {
	return async (dispatch, getState) => {
		let body = {
			supplier_product_id,
		};
		let response = await dentalCorpBackend.deleteInventory(getState(), body, dispatch);
		if (response !== null && response !== undefined) {
			dispatch({ type: DELETE_INVENTORY, payload: response.response });
		}
	};
};

export const addBulkItems = (body) => {
	return async (dispatch, getState) => {
		let response = await dentalCorpBackend.addBulkItems(getState(), body, dispatch);
		if (response !== null && response !== undefined) {
			return response.response;
		}
	};
};

export const updateBulkItemsAndStatus = (body) => {
	return async (dispatch, getState) => {
		let response = await dentalCorpBackend.updateBulkItemsAndStatus(getState(), body, dispatch);
		if (response !== null && response !== undefined) {
			return response.response;
		}
	};
};

export const updateBulkBucketPrices = (body) => {
	return async (dispatch, getState) => {
		let response = await dentalCorpBackend.updateBulkBucketPrices(getState(), body, dispatch);
		if (response !== null && response !== undefined) {
			return response.response;
		}
	};
};

export const setUploadInventoryFileAction = (showUploadInventoryFile = false, uploadInventoryFileType = '', uploadInventoryFileAction = '') => {
	return async (dispatch, getState) => {
		dispatch({ type: SET_UPLOAD_INVENTORY_FILE_ACTION, payload: { showUploadInventoryFile, uploadInventoryFileType, uploadInventoryFileAction } });
	};
};

export const setUploadInventoryFileBatch = (uploadInventoryFileBatch = '') => {
	return async (dispatch, getState) => {
		dispatch({ type: SET_UPLOAD_INVENTORY_FILE_BATCH, payload: { uploadInventoryFileBatch } });
	};
};

export const fetchUploadInventoryFileBatch = () => {
	return async (dispatch, getState) => {
		const actionTypes = [SPJ_ACTIONS.INVENTORY_CREATE, SPJ_ACTIONS.INVENTORY_UPDATE, SPJ_ACTIONS.LAB_INVENTORY_CREATE, SPJ_ACTIONS.LAB_INVENTORY_UPDATE, SPJ_ACTIONS.PRICE_UPDATE];
		const pendingBatches = await dentalCorpBackend.fetchSPJActiveBatches(getState(), SPJ_STATUS.PENDING, '', dispatch);
		if (pendingBatches && pendingBatches.length > 0 && actionTypes.includes(pendingBatches[0].event)) {
			let pendingBatch = pendingBatches[0];
			await dispatch(setUploadInventoryFileBatch(pendingBatch.batch_id));
			await dispatch(setUploadInventoryFileAction(true, pendingBatch.event, BULK_FILE_UPLOAD_STAGES.PROCESSING));
		} else {
			const failedBatches = await dentalCorpBackend.fetchSPJActiveBatches(getState(), SPJ_STATUS.FAILED, '', dispatch);
			if (failedBatches && failedBatches.length > 0 && actionTypes.includes(failedBatches[0].event)) {
				let failedBatch = failedBatches[0];
				await dispatch(setUploadInventoryFileBatch(failedBatch.batch_id));
				await dispatch(setUploadInventoryFileAction(true, failedBatch.event, BULK_FILE_UPLOAD_STAGES.FILE_ERRORS));
			}
		}
	};
};

export const downloadTemplateFile = (action = '', onFailure = null, body) => {
	return async (dispatch, getState) => {
		await dentalCorpBackend.downloadTemplateFile(getState(), action, body, dispatch);
	};
};

export const uploadFilledTemplateFile = (action = '', body, onSuccess = null, onFailure = null) => {
	return async (dispatch, getState) => {
		await dentalCorpBackend.uploadFilledTemplateFile(getState(), action, body, onSuccess, onFailure, dispatch);
	};
};

export const downloadInventoryData = (action = '', body = {}, onFailure = null) => {
	return async (dispatch, getState) => {
		await dentalCorpBackend.downloadInventoryData(getState(), action, body, dispatch);
	};
};

export const downloadInventoryPrices = (action = '', body = {}, onFailure = null) => {
	return async (dispatch, getState) => {
		await dentalCorpBackend.downloadInventoryPrices(getState(), action, body, dispatch);
	};
};

export const fetchDentiraMapping = (supplier_product_id) => {
	return async (dispatch, getState) => {
		let body = {
			supplier_product_id,
		};
		let response = await dentalCorpBackend.fetchDentiraMapping(getState(), body, dispatch);
		if (response !== null && response !== undefined) {
			return response.response;
		}
	};
};

export const addDentiraMapping = (mapping) => {
	return async (dispatch, getState) => {
		let body = { mapping };
		let response = await dentalCorpBackend.addDentiraMapping(getState(), body, dispatch);
		if (response !== null && response !== undefined) {
			return response.response;
		}
	};
};

export const updateDentiraMapping = (oldMapping, newMapping) => {
	return async (dispatch, getState) => {
		let body = {
			old_mapping: oldMapping,
			new_mapping: newMapping,
		};
		let response = await dentalCorpBackend.updateDentiraMapping(getState(), body, dispatch);
		if (response !== null && response !== undefined) {
			return response.response;
		}
	};
};

export const removeDentiraMapping = (mapping) => {
	return async (dispatch, getState) => {
		let body = { mapping };
		let response = await dentalCorpBackend.removeDentiraMapping(getState(), body, dispatch);
		if (response !== null && response !== undefined) {
			return response.response;
		}
	};
};

export const fetchAutocompleteDentiraProducts = (category = '', search = '', size = 10, page = 1, addOns = false) => {
	return async (dispatch, getState) => {
		let response = await dentalCorpBackend.fetchAutocompleteDentiraProducts(getState(), category, search, size, page, addOns, dispatch);
		if (response !== null && response !== undefined) {
			return response.response || [];
		}
	};
};

export const fetchAutocompleteDentiraPrimaryProducts = (params, body) => {
	return async (dispatch, getState) => {
		let response = await dentalCorpBackend.fetchAutocompleteDentiraPrimaryProducts(getState(), params, body, dispatch);
		if (response !== null && response !== undefined) {
			return response.response || [];
		}
	};
};

export const fetchAutocompleteDentiraAddOnsProducts = (params, body) => {
	return async (dispatch, getState) => {
		let response = await dentalCorpBackend.fetchAutocompleteDentiraAddOnsProducts(getState(), params, body, dispatch);
		if (response !== null && response !== undefined) {
			return response.response || [];
		}
	};
};

export const fetchDentiraProductCategories = (addOns) => {
	return async (dispatch, getState) => {
		let response = await dentalCorpBackend.fetchDentiraProductCategories(getState(), addOns, dispatch);
		return response.response || [];
	};
};

export const fetchDentiraProductFilters = (filters) => {	
	return async (dispatch, getState) => {
		let response = await dentalCorpBackend.fetchDentiraProductFilters(getState(), filters, dispatch);
		return response.response || [];
	};
};
